import { createRoute, redirect } from '@tanstack/react-router';

import { rootRoute } from './__root';

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: ({ context }) => {
    // if (context.authStore.accessToken) throw redirect({ to: '/dashboard', replace: true });
    if (context.authStore.accessToken) throw redirect({ to: '/transaction', replace: true });
    else throw redirect({ to: '/auth/login' });
  },
});
